import { Link } from 'react-router-dom';
import type { Requirement } from '../api/requirements';
import { ClassBadge } from './ClassBadge';
import { CustomerMark } from './CustomerMark';
import { StatusPipeline } from './StatusPipeline';
import { relTime } from '../lib/relTime';
import { titleOf, summaryPreview, shortId } from '../lib/requirementText';

type Props = {
  readonly requirement: Requirement;
};

export function RequirementRow({ requirement }: Props) {
  const missing = requirement.missingInfo?.length ?? 0;
  const hasError = !!requirement.lastError;
  const summary = summaryPreview(requirement);
  return (
    <Link to={`/inbox/${requirement.id}`} className="row">
      <div className="cell-title">
        <div className="t">
          <span className="id">{shortId(requirement.id)}</span>
          {titleOf(requirement)}
        </div>
        {summary && <div className="s">{summary}</div>}
        {(requirement.project || missing > 0 || hasError) && (
          <div className="chips">
            {requirement.project && (
              <span className="minichip">{requirement.project}</span>
            )}
            {missing > 0 && (
              <span className="minichip warn">{missing} offen</span>
            )}
            {hasError && <span className="minichip error">Fehler</span>}
          </div>
        )}
      </div>
      <div>
        <ClassBadge classification={requirement.classification} />
      </div>
      <CustomerMark name={requirement.customer} />
      <StatusPipeline status={requirement.status} />
      <div className="cell-time">
        <div className="rel">{relTime(requirement.createdAt)}</div>
      </div>
      <div className="cell-action">
        <span className="row-btn">Öffnen</span>
      </div>
    </Link>
  );
}
